import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { ReactComponent as MenuImg } from "../../assets/images/file.svg";

import { getCartItemsTotalPrice, isObject } from "../../constants/CommonFunc";
import { formatPrice } from "../../constants";

const OrderModalItemList = (props) => {
  let item = props.item;

  let modifiers = [];

  // Handle modifiers from order history data structure
  if (item?.modifiers && Array.isArray(item.modifiers)) {
    item.modifiers.forEach((modifier) => {
      if (modifier?.menuItem?.name && modifier?.quantity) {
        const itemPrice = modifier?.price?.value ?? 0;
        const currency = modifier?.price?.currency ?? item?.price?.currency ?? 'GBP';
        const totalModifierPrice = itemPrice * modifier.quantity;
        modifiers.push(`${modifier.quantity} ${modifier.menuItem.name} (${currency} ${formatPrice(itemPrice, currency)} each = ${currency} ${formatPrice(totalModifierPrice, currency)})`);
      }
    });
  }

  // Handle legacy cartModifier structure
  else if (item?.cartModifier) {
    item?.cartModifier?.forEach((mod1, i1) => {
      if (isObject(mod1)) {
        const price = mod1?.price?.value || mod1?.menuData?.price?.value;
        const currency = mod1?.price?.currency || mod1?.menuData?.price?.currency || item?.price?.currency || 'GBP';
        const priceText = price ? ` (${currency} ${formatPrice(price, currency)})` : '';
        modifiers.push([mod1?.withExtra + " " + mod1?.menuData?.name + priceText]);
      } else {
        const modifier = Array.isArray(mod1) ? mod1 : JSON.parse(mod1);
        const mod = modifier?.map((y1) => {
          const price = y1?.price?.value || y1?.menuData?.price?.value;
          const currency = y1?.price?.currency || y1?.menuData?.price?.currency || item?.price?.currency || 'GBP';
          const priceText = price ? ` (${currency} ${formatPrice(price, currency)})` : '';
          return y1?.withExtra + " " + y1?.menuData?.name + priceText;
        });
        if (mod.length) {
          modifiers.push(mod);
        }
      }
    });
  }

  // Calculate total price including modifiers
  let totalPrice = (item?.price?.value ?? 0) * (item?.quantity ?? 1);
  if (item?.modifiers && Array.isArray(item.modifiers)) {
    item.modifiers.forEach((modifier) => {
      totalPrice += (modifier?.price?.value ?? 0) * (modifier?.quantity ?? 0);
    });
  } else {
    totalPrice = getCartItemsTotalPrice(item, []) ?? 0;
  }

  return (
    <Box px={3} pt={2} sx={styles.mainView}>
      <Box mr={2}>
        {item.images?.length ? (
          <Box sx={styles.imageView}>
            <img src={item.images[0]} style={styles.imageStyle} alt={item.name || "Menu item"} />
          </Box>
        ) : (
          <Box sx={{ ...styles.imageView, ...styles.menuImgView }}>
            <MenuImg width={"40%"} height={"40%"} />
          </Box>
        )}
      </Box>
      <Box
        pb={2}
        sx={{
          ...styles.dataView,
          borderBottom: props.lastIndex ? 0 : "1px solid #DEDEDE",
        }}
      >
        <Box mb={1} sx={styles.nameAddOnView}>
          <Typography sx={styles.nameText}>{item.menuItemName || item.name}</Typography>
          <Typography sx={styles.priceText}>
            {item?.price?.currency} {formatPrice(item?.price?.value, item?.price?.currency)}
          </Typography>
        </Box>
        {modifiers.length
          ? modifiers.map((modifier, i2) => {
            return (
              <Typography
                key={i2}
                mt={1}
                sx={styles.noteText}
                style={{ color: "#272D2F" }}
              >
                -- {Array.isArray(modifier) ? modifier.join(", ") : modifier}
              </Typography>
            );
          })
          : null}

        {item?.notes ? (
          <Typography my={1} sx={styles.noteText}>
            Notes : {item.notes}
          </Typography>
        ) : null}
        <Box sx={styles.priceQtyView}>
          <Typography sx={styles.priceText}>
            Total: {item?.quantity}x {item?.price?.currency} {formatPrice(totalPrice, item?.price?.currency)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderModalItemList;

const styles = {
  mainView: {
    display: "flex",
    flexDirection: "row",
  },
  dataView: {
    flex: 1,
  },
  imageView: {
    width: 56,
    height: 56,
    borderRadius: 28,
    overflow: "hidden",
  },
  menuImgView: {
    backgroundColor: "#EEEEEE",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageStyle: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  nameAddOnView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  nameText: {
    color: "#000000",
    fontFamily: "GilroyBold",
    fontSize: 16,
  },
  addOnView: {
    border: "1px solid #DEDEDE",
    borderRadius: 37,
    px: 1,
  },
  addOnText: {
    color: "#000000",
    fontFamily: "GilroyBold",
    fontSize: 12,
  },
  noteText: {
    color: "#000000",
    fontFamily: "GilroyMedium",
    fontSize: 12,
    lineHeight: "13px",
  },
  priceQtyView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  priceText: {
    color: "#000000",
    fontFamily: "GilroyBold",
    fontSize: 14,
  },
  qtyText: {
    color: "#000000",
    fontFamily: "GilroyBold",
    fontSize: 14,
  },
};
